import { FC_TRANSFER_LINE_STATUS } from 'components/warehouse/components/fcTransfers/fcTransferReceiveBadgeStyles';

/**
 * True when the line was received at zero (no destination lot / pallet UI).
 * Detected via `received_zero` discrepancy + null destinationLotId.
 *
 * @param {Record<string, unknown> | null | undefined} item
 * @returns {boolean}
 */
export function isFcTransferItemReceivedZero(item) {
    if (!item || typeof item !== 'object') {
        return false;
    }
    const destinationLotId = item?.receivedItem?.destinationLotId ?? item?.destinationLotId;
    if (destinationLotId !== null && destinationLotId !== undefined && destinationLotId !== '') {
        return false;
    }
    const discrepancies = Array.isArray(item.discrepancies) ? item.discrepancies : [];
    return discrepancies.some((raw) => {
        if (!raw || typeof raw !== 'object') {
            return false;
        }
        const type = String(raw.discrepancyType ?? raw.discrepancy_type ?? '').trim();
        return type === 'received_zero';
    });
}

/**
 * Default visibility when `canReceive` / `canEdit` are omitted from the API payload (tech spec §4.2).
 *
 * @param {Record<string, unknown>} item
 * @returns {boolean}
 */
export function getDefaultCanReceiveLine(item) {
    if (item?.canReceive === false) {
        return false;
    }
    if (item?.canReceive === true) {
        return true;
    }
    const s = String(item?.status ?? '').toUpperCase();
    return s === FC_TRANSFER_LINE_STATUS.PENDING;
}

/**
 * @param {Record<string, unknown>} item
 * @returns {boolean}
 */
export function getDefaultCanEditLine(item) {
    if (item?.canEdit === false) {
        return false;
    }
    if (item?.canEdit === true) {
        return true;
    }
    const s = String(item?.status ?? '').toUpperCase();
    return s === FC_TRANSFER_LINE_STATUS.IN_RECEIPT;
}
